// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_aiC","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_QKz FallbackBulkDownloadUpsellModalControl-cls1_aiC"};